import IPhysicalAnalysisFailure from 'types/model/IPhysicalAnalysisFailure';
import { failureExplanation } from './failureExplanation';

// `t` falso: devuelve la clave seguida de las opciones, asi se ve que se tradujo y con que.
const t = (key: string, options: { [key: string]: string } = {}) => {
  const values = Object.keys(options)
    .map((name) => `${name}=${options[name]}`)
    .join(' ');

  return values ? `${key}(${values})` : key;
};

const SCOPE = 'physical_analysis.failure_info';

const detail = (
  overrides: Partial<IPhysicalAnalysisFailure> = {}
): IPhysicalAnalysisFailure => ({
  field: 'sieve_15_percentage',
  violation: 'above_max',
  measured: 97.96,
  min: null,
  max: 96,
  unit: 'percentage',
  grams: 240,
  green: 245,
  processType: null,
  processTypeId: null,
  overridable: true,
  parameterId: null,
  ...overrides,
});

describe('failureExplanation', () => {
  it('explica un maximo incumplido sobre la almendra (caso beta, malla 15-18)', () => {
    expect(failureExplanation(detail(), t)).toEqual({
      title: `${SCOPE}.title.above_max`,
      lines: [
        `${SCOPE}.measured(value=${SCOPE}.of_green(value=97.96 % grams=240.00 green=245.00))`,
        `${SCOPE}.allowed_max(max=96.00 %)`,
        `${SCOPE}.process(process=purchase_physical_analysis_parameters.any_process)`,
      ],
    });
  });

  it('explica un minimo incumplido', () => {
    const { title, lines } = failureExplanation(
      detail({ violation: 'below_min', min: 0, max: null, measured: 0, grams: 0 }),
      t
    );

    expect(title).toBe(`${SCOPE}.title.below_min`);
    expect(lines[1]).toBe(`${SCOPE}.allowed_min(min=0.00 %)`);
  });

  it('muestra el rango cuando hay minimo y maximo', () => {
    const { lines } = failureExplanation(detail({ min: 0, max: 3 }), t);

    expect(lines[1]).toBe(`${SCOPE}.allowed_range(min=0.00 % max=3.00 %)`);
  });

  it('no agrega gramos ni unidad a un factor, y nombra el proceso de la fila', () => {
    const { lines } = failureExplanation(
      detail({
        field: 'factor_14',
        unit: 'factor',
        measured: 93.1,
        max: 92,
        grams: null,
        green: null,
        processType: 'Natural',
      }),
      t
    );

    expect(lines).toEqual([
      `${SCOPE}.measured(value=93.10)`,
      `${SCOPE}.allowed_max(max=92.00)`,
      `${SCOPE}.process(process=Natural)`,
    ]);
  });

  it('sin valor medido no muestra la linea de medicion', () => {
    const { title, lines } = failureExplanation(
      detail({ violation: 'missing', measured: null, grams: null }),
      t
    );

    expect(title).toBe(`${SCOPE}.title.missing`);
    expect(lines).toHaveLength(2);
  });
});
